import { c as _c } from "react/compiler-runtime";
import { buttonVariants } from "@/components/ui/Button";
import { Toaster as Sonner } from "sonner";
import cn from "twsx";
type ToasterProps = React.ComponentProps<typeof Sonner>;

// Toasts sit on the menu/popover surface (see menu-surface.ts): white, 1px
// popover border, 12px radius, popover elevation, 13px text. Tone shows only
// in the icon, so an error toast reads like Linear's rather than a red slab.
// Sonner runs unstyled: its styled layer paints buttons with a selector the
// catalog classes cannot outrank, so the toast owns its surface and its
// action and cancel buttons are the catalog Button.
const toastClassName = cn("flex w-full items-center gap-1.5 p-4", "rounded-popover border border-border-popover bg-bg-surface text-base text-text-primary shadow-pop", "data-[expanded=false]:data-[front=false]:[&>*]:opacity-0");
const closeButtonClassName = "border-border-popover bg-bg-surface text-text-tertiary";

/** Use when mounting the app root so toast notifications can render. */
const Toaster = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      unstyled: true,
      classNames: {
        toast: toastClassName,
        content: "flex-1",
        title: "font-medium",
        description: "text-text-tertiary",
        icon: "text-text-tertiary",
        actionButton: buttonVariants({
          variant: "primary",
          size: "sm"
        }),
        cancelButton: buttonVariants({
          variant: "secondary",
          size: "sm"
        }),
        closeButton: closeButtonClassName,
        success: "[&_[data-icon]]:text-green-text",
        error: "[&_[data-icon]]:text-red-text",
        info: "[&_[data-icon]]:text-blue-text",
        warning: "[&_[data-icon]]:text-yellow-text"
      }
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <Sonner theme="light" toastOptions={t1} {...props} />;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Toaster };